import { createSelector } from 'reselect';

import { selectUnderwriting } from './underwriting.selectors';

export const selectConditionCategories = createSelector(
  selectUnderwriting,
  ({ conditionCategories }) => conditionCategories ?? [],
);

const selectEnabledConditionCategories = createSelector(selectConditionCategories, categories =>
  categories.filter(({ isEnabled }) => isEnabled !== false),
);

export const selectConditionCategoryOptions = createSelector(
  selectEnabledConditionCategories,
  categories =>
    categories.map(({ id, name }) => ({
      value: id,
      label: name,
    })),
);
